import { isNullOrUndefined } from "../commonUtilities";
import {compareObjects, deepCopyObject, objectHasProperty} from "./objectUtilities";
import { isArray, isString } from "./typeUtilities";
import _ from "lodash";

export function isInArray<T>(array: T[], value: T): boolean {
    return array.includes(value);
}

export function isArrayNullOrEmpty(array: unknown): boolean {
    return isNullOrUndefined(array) || !(isArray(array) && array.length !==0);
}

export function addUniqueValueToArray<T>(array: T[] | null | undefined, value: T): T[] {
    let result: T[] = !array ? [] : convertToArray(array) as T[];

    if (!isInArray(result, value))
        result.push(value);

    return result;
}

export function convertToArray(unknownType: unknown, delimiter = ","): unknown[] {
    return isNullOrUndefined(unknownType) ?
        [] :
        isArray(unknownType) ?
            unknownType :
            isString(unknownType) ?
                unknownType.split(delimiter) :
                [unknownType];
}

export function deepCopyArray<T>(array: T[] = []): T[] {
    return deepCopyObject(array);
}

export function arraysEqual(a: unknown[], b: unknown[]): boolean {
    return compareObjects(a, b);
}

export function arraysOfObjectsEqual(a: unknown[], b: unknown[]): boolean {
    return compareObjects(a, b);
}

export function filterObjectArrayByField(array: Record<string, unknown>[], filter: unknown, field: string): Record<string, unknown>[] {
    if (!filter || isArrayNullOrEmpty(array)) return [];

    let result;
    const searchStrings = filter.toString().split(",").map((d: string) => d.trim());
    result = array.filter((ins) =>
        searchStrings.some(function(search: string) {
            return String(ins[field]) === search;
        }),
    );

    return result;
}

export function filterObjectArrayByAllFields(array: Record<string, unknown>[], searchString: string): Record<string, unknown>[] {
    if (isArrayNullOrEmpty(array)) return [];

    return array.filter(obj => {
        return Object.keys(obj).some(key => {
            if (typeof obj[key] === 'string') {
                const lowerCaseValue = obj[key].toLowerCase();
                const searchArray = searchString.toLowerCase().split(" ");
                return searchArray.every(str => lowerCaseValue.includes(str));
            }
            return false;
        });
    });
}

export function findObjectArrayByField(array: Record<string, unknown>[], filter: unknown, field: string): Record<string, unknown> | undefined {
    return filterObjectArrayByField(array, filter, field)[0];
}

export function createArrayFromObject<T = unknown>(object: Record<string, T>): T[] {
let result: T[] = [];
    for (let property in object) {
        if (objectHasProperty(object, property)) {
            result.push(object[property]);
        }
    }
    return result;
}

export function optionIndexInArray(array: unknown[], option: unknown = "", wholeWord = true): number {
    if (isNullOrUndefined(option) || isArrayNullOrEmpty(array)) return -1;

    const optionValue = String(option).toLowerCase();

    for (let i =0; i < array.length; i++) {
        if(isNullOrUndefined(array[i]))
            continue;
        const arrayValue = String(array[i]).toLowerCase();
        if ((wholeWord && arrayValue === optionValue) || (!wholeWord && arrayValue.startsWith(optionValue)))
            return i;
    }

    return -1;
}

export function partialOptionIndexInArray(array: unknown[], option: unknown = ""): number {
    if (isNullOrUndefined(option) || isArrayNullOrEmpty(array)) return -1;

    const optionValue = String(option).toLowerCase();

    for (let i =0; i < array.length; i++) {
        if (isNullOrUndefined(array[i])) continue;
        const arrayValue = String(array[i]).toLowerCase();
        if (optionValue.startsWith(arrayValue)) return i;
    }

    return -1;
}

export function getDistinctValuesByObjectProperty<T>(array: T[], property: keyof T): unknown[] {
    return [
        ...new Set(
            array.map((item) => {
                return item[property];
            }),
        ),
    ];
}

export function sortArrayOfObjectsByProperty<T>(array: T[], property: keyof T & string): T[] {
    return _.sortBy([...array], [property]);
}

export function getFieldArrayFromObjectArrayByField<T extends Record<string, unknown>>(objectArray: T[], field: string): unknown[] {
return objectArray.map(obj => obj[field]);
}
